// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Caml_format from "../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as ReactModal from "react-modal";
import * as CityVehicleCmp from "../reusable-components/CityVehicleCmp.bs.js";
import * as ZoneClusterVmMapper from "../../../../view-model/zone-cluster-campaign/ZoneClusterVmMapper.bs.js";
import * as AllocationCampaignValidation from "./AllocationCampaignValidation.bs.js";
import * as AllocationDashboardAssetsManager from "../../../../assets/AllocationDashboardAssetsManager.bs.js";
import * as PreviewZonalOrClusterCampaignCmp from "../create-campaign/preview-campaign/PreviewZonalOrClusterCampaignCmp.bs.js";

var arrowDropDownRedIcon = AllocationDashboardAssetsManager.getImage("red-arrow-drop-down.svg");

var arrowDropDownGreenIcon = AllocationDashboardAssetsManager.getImage("green-arrow-drop-down.svg");

var closeIcon = AllocationDashboardAssetsManager.getImage("close-icon.svg");

var infoIcon = AllocationDashboardAssetsManager.getImage("info-icon.svg");

function toFixedDecimalPoint(value, decimalPoint) {
  return Caml_format.caml_float_of_string(value.toFixed(decimalPoint));
}

function getDeltaValue(campaign_filter_value, active_mandatory_campaign_filter_value) {
  return campaign_filter_value - active_mandatory_campaign_filter_value;
}

function getCreatorInfo(preview_data) {
  return React.createElement("div", {
              className: "section"
            }, React.createElement(PreviewZonalOrClusterCampaignCmp.GetCreatorInfo.make, {
                  created_by: preview_data.creation_info.actor.email_id,
                  created_on: preview_data.creation_info.time,
                  status: preview_data.status
                }));
}

function getApproverInfo(preview_data) {
  var approver = preview_data.approval_info;
  if (approver !== undefined) {
    return React.createElement("div", {
                className: "section"
              }, React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("p", undefined, "Approved By"), React.createElement("p", {
                        className: "value"
                      }, approver.actor.email_id)), React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("p", undefined, "Approved On"), React.createElement("p", {
                        className: "value"
                      }, approver.time)));
  } else {
    return null;
  }
}

function getTimingDateAndActiveDaysInfo(preview_data) {
  return React.createElement("div", {
              className: "section"
            }, React.createElement(PreviewZonalOrClusterCampaignCmp.GetTimingDateAndActiveDaysInfo.make, {
                  type: preview_data.campaign_type,
                  startDate: preview_data.effective_from,
                  startTime: preview_data.day_start_time,
                  endTime: preview_data.day_end_time,
                  endDate: preview_data.effective_till,
                  days: preview_data.days_of_week
                }));
}

function getListOfZones(preview_data) {
  var match = List.length(preview_data.zones);
  if (match !== 1) {
    return React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("p", {
                        className: ""
                      }, "List of Zones")), React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("div", {
                        className: "selected-zones-container"
                      }, Belt_List.toArray(List.map((function (zone) {
                                  return React.createElement("label", {
                                              className: "selected-zones"
                                            }, zone.toUpperCase());
                                }), preview_data.zones)))));
  } else {
    return React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("p", {
                        className: ""
                      }, "Zone"), React.createElement("p", {
                        className: "value"
                      }, Belt_List.getExn(preview_data.zones, 0))));
  }
}

function getListOfClusters(preview_data) {
  var match = List.length(preview_data.clusters);
  if (match !== 0) {
    return React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("p", undefined, "List of Clusters")), React.createElement("div", {
                    className: "section-row"
                  }, React.createElement("div", {
                        className: "selected-clusters-container"
                      }, Belt_List.toArray(List.map((function (cluster) {
                                  return React.createElement("label", {
                                              className: "selected-clusters"
                                            }, cluster.toUpperCase());
                                }), preview_data.clusters)))));
  } else {
    return React.createElement(React.Fragment, undefined, null);
  }
}

function getZonesAndClusters(preview_data) {
  return React.createElement("div", {
              className: "section"
            }, getListOfZones(preview_data), getListOfClusters(preview_data));
}

function getValidations(preview_data) {
  var validationData = preview_data.validation;
  if (validationData !== undefined) {
    return React.createElement(AllocationCampaignValidation.make, {
                validationData: validationData
              });
  } else {
    return null;
  }
}

function getFilterType(preview_data, active_mandatory_campaign) {
  return React.createElement("div", {
              className: "section"
            }, React.createElement(PreviewZonalOrClusterCampaignCmp.GetFilterType.make, {
                  subType: preview_data.sub_type,
                  infoIconDescription: preview_data.filter_info,
                  left_value: preview_data.filter.left_value,
                  right_value: preview_data.filter.right_value,
                  radius_delta: preview_data.filter.radius_delta,
                  active_mandatory_campaign: active_mandatory_campaign
                }));
}

function AllocationCampaignDetailModal(Props) {
  var mandatory_campaign = Props.mandatory_campaign;
  var selected_geo_region = Props.selected_geo_region;
  var selected_vehicle = Props.selected_vehicle;
  var modification = Props.modification;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var close_modal = Props.close_modal;
  var modificationVmData = ZoneClusterVmMapper.VMMapper.getViewModel(modification, zones, clusters);
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: close_modal,
              overlayClassName: "modal-overlay",
              className: "modal-content c-allocation-campaign-detail-modal",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: "allocation-campaign-detail-modal-header"
                      }, React.createElement("div", {
                            className: "campaign-details-header"
                          }, React.createElement("p", {
                                className: "campaign-name"
                              }, modification.name), React.createElement("div", {
                                className: "view-campaign-actions"
                              }, React.createElement("span", {
                                    onClick: (function (_event) {
                                        return Curry._1(close_modal, undefined);
                                      })
                                  }, React.createElement("img", {
                                        className: "action",
                                        src: closeIcon
                                      }))))), React.createElement("div", {
                        className: "c-preview-zonal-cluster-campaign"
                      }, React.createElement(CityVehicleCmp.make, {
                            vehicle_name: selected_vehicle,
                            geo_region: selected_geo_region
                          }), getCreatorInfo(modificationVmData), getApproverInfo(modificationVmData), getValidations(modificationVmData), getTimingDateAndActiveDaysInfo(modificationVmData), getZonesAndClusters(modificationVmData), getFilterType(modificationVmData, mandatory_campaign)))
            });
}

var make = AllocationCampaignDetailModal;

export {
  arrowDropDownRedIcon ,
  arrowDropDownGreenIcon ,
  closeIcon ,
  infoIcon ,
  toFixedDecimalPoint ,
  getDeltaValue ,
  getCreatorInfo ,
  getApproverInfo ,
  getTimingDateAndActiveDaysInfo ,
  getListOfZones ,
  getListOfClusters ,
  getZonesAndClusters ,
  getValidations ,
  getFilterType ,
  make ,
  
}
/* arrowDropDownRedIcon Not a pure module */
